import React from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import * as Actions from '../../actions/actions';

const RouteSummaryGridPanel = ({ routeSummaryData, pagination, sorting, ...props }) => {

    const columns = [
        { field: 'local_route', headerName: 'Route', width: 120 },
        { field: 'national_route', headerName: 'National Route', width: 150 },
        { field: 'dock_door', headerName: 'Door', width: 120 },
        { field: 'status', headerName: 'Status', width: 120 },
        { field: 'loaded_count', headerName: 'Pallets Loaded', width: 140, type: 'number' },
        { field: 'expected_count', headerName: 'Pallets Expected', width: 150, type: 'number' },
        { 
            field: 'completion_pct', 
            headerName: '% Loaded', 
            width: 120, 
            type: 'number',
            valueFormatter: (params) => `${params.value || 0}%`
        },
        { field: 'smart_count', headerName: 'Smart', width: 100, type: 'number' },
        { field: 'non_smart_count', headerName: 'Non-Smart', width: 120, type: 'number' },
        { field: 'return_count', headerName: 'Returns', width: 100, type: 'number' },
        { field: 'total_throughput', headerName: 'Total Throughput', width: 160, type: 'number' },
        { field: 'not_detected_count', headerName: 'Not Detected', width: 140, type: 'number' },
        { field: 'error_count', headerName: 'Errors', width: 100, type: 'number' }
    ];

    const handleSortModelChange = (model) => {
        if (model.length > 0) {
            const { field, sort } = model[0];
            props.updateSort(field, sort);
        }
    };

    const handlePageChange = (newPage) => {
        props.updatePage(newPage);
    };

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: "100%" }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>ROUTE SUMMARY</h3>
                </div>
                <div className="duolift-device-detail-card-body">
                    <div style={{ height: '440px', width: '100%' }}>
                        <DataGrid
                            rows={routeSummaryData || []}
                            columns={columns}
                            pageSize={pagination.pageSize}
                            rowsPerPageOptions={[50]}
                            page={pagination.page}
                            rowCount={pagination.totalCount}
                            paginationMode="server"
                            sortingMode="server"
                            onSortModelChange={handleSortModelChange}
                            onPageChange={handlePageChange}
                            getRowId={(row) => row.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    routeSummaryData: state.loadValidationDashboard.routeSummaryData,
    pagination: state.loadValidationDashboard.pagination.routeSummary,
    sorting: state.loadValidationDashboard.sorting.routeSummary
});

const mapDispatchToProps = (dispatch) => ({
    updateSort: (sortBy, sortOrder) => dispatch(Actions.UPDATE_ROUTE_SUMMARY_SORT(sortBy, sortOrder)),
    updatePage: (page) => dispatch(Actions.UPDATE_ROUTE_SUMMARY_PAGE(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteSummaryGridPanel);
